import { authApiCall } from '../auth/saga';

/**
 * NOTE: no `customerPreferences` module existed anywhere (web or mobile zip
 * provided). Built here to back Preferences (saved category interests +
 * coupon search range). Endpoint names are a best guess following existing
 * `/users/...`-style conventions used elsewhere (signup, passwords) —
 * verify against the real backend before relying on this.
 */
export const getPreferences = () =>
  authApiCall({
    url: '/users/customer-preferences/',
    method: 'get',
  });

export const updatePreferences = data =>
  authApiCall({
    url: '/users/customer-preferences/',
    method: 'patch',
    data,
  });
